
import { Component, Vue, Prop } from 'vue-property-decorator'
import { IAppForm } from './../IAppForm'
import { ApplicationModule } from '@/store'

import EmploymentDto from '../../../types/dto/employmentDto'
import CFInput from '../../inputs/CFInput'

	@Component({
	  name: 'EmploymentDetails'
	})
export default class EmploymentDetails extends Vue implements IAppForm {
		// #region  Props
		@Prop() employment!: EmploymentDto;
		@Prop() wizardIndex!: number;
		@Prop({ default: true }) showOccupation!: boolean;
		@Prop({ default: true }) showName!: boolean;
		@Prop({ default: true }) showTown!: boolean;

		// #endregion

		// #region Data

		netMonthlyIncome: number | null = null;

		get value () {
		  return ApplicationModule.form
		}

		// #endregion

		mounted () {
		  this.netMonthlyIncome = this.value.netMonthlyIncome
		}

		// #region Methods

		submit () {
		  if (!this.validate()) { return }

		  this.$emit('submit', this.wizardIndex)
		}

		validate () {
		  const valid = this.validateData()

		  return valid
		}

		validateData () {
		  const showOccupationError = this.showOccupation ? !(this.$refs.occupation as unknown as CFInput).validate() : false
		  const showNameError = this.showName ? !(this.$refs.employmentName as unknown as CFInput).validate() : false
		  const showTownError = this.showTown ? !(this.$refs.employmentTown as unknown as CFInput).validate() : false
		  let showIncomeError = false

		  // Only need net income for most recent employment
		  if (this.employment.employmentLevel <= 0) {
		    if (!this.netMonthlyIncome) {
		      (this.$refs.employmentNetIncome as unknown as CFInput).valid = false
		      showIncomeError = true
		      return false
		    }

		    const income = Number(this.netMonthlyIncome)
		    showIncomeError = !(!isNaN(income) && income >= 0)
		    if (showIncomeError) {
		      (this.$refs.employmentNetIncome as unknown as CFInput).valid = false
		    }
		  }

		  if (showOccupationError || showNameError || showTownError || showIncomeError) {
		    return false
		  }

		  return true
		}

		get editingEmploymentIndex () {
		  return ApplicationModule.editingEmploymentIndex ?? -1
		}

		incomeSet () {
		  this.value.netMonthlyIncome = this.netMonthlyIncome
		}
}
